import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaListAlt, FaExchangeAlt } from "react-icons/fa";

const GREEN = "#2e7d32";

function SelectType() {
  const { category } = useParams();
  const navigate = useNavigate();

  const isMowing = category === "mowing";
  const isCleaning = category === "cleaning";
  const isPool = category === "pool";

  return (
    <div style={containerStyle}>
      <h2>CREATE A NEW LISTING</h2>
      <p style={{ color: "#666", marginBottom: 30 }}>
        Creating a{" "}
        {isMowing && "Lawn Mowing"}
        {isCleaning && "Cleaning"}
        {isPool && "Pool Care"}{" "}
        listing
      </p>

      <div style={gridStyle}>
        {/* ================= MOWING ================= */}
        {isMowing && (
          <>
            <Card
              icon={<FaListAlt />}
              color={GREEN}
              title="List a Lawn Mowing Client"
              onClick={() => navigate("/post-listing")}
            />

            <Card
              icon={<FaExchangeAlt />}
              color={GREEN}
              title="Swap a Lawn Mowing Client"
              onClick={() => navigate("/post-swap")}
            />

            <Card
              icon={<FaListAlt />}
              color={GREEN}
              title="List a Lawn Mowing Round"
              onClick={() => navigate("/lawn-mowing/rounds/new")}
            />

            <Card
  icon={<FaListAlt />}
  color={GREEN}
  title="List a Lawn Mowing Business"
  onClick={() => navigate("/lawn-mowing/businesses/new")}
/>
          </>
        )}

        {/* ================= CLEANING ================= */}
        {isCleaning && (
          <>
            <Card
              icon={<FaListAlt />}
              color={GREEN}
              title="List a Cleaning Client"
              onClick={() => navigate("/cleaning/post-listing")}
            />

            <Card
              icon={<FaExchangeAlt />}
              color={GREEN}
              title="Swap a Cleaning Client"
              onClick={() => navigate("/cleaning/post-swap")}
            />

            <Card
              icon={<FaListAlt />}
              color={GREEN}
              title="List a Cleaning Round"
              onClick={() => navigate("/cleaning/rounds/new")}
            />
          </>
        )}

        {/* ================= POOL CARE ================= */}
        {isPool && (
          <>
            <Card
              icon={<FaListAlt />}
              color={GREEN}
              title="List a Pool Care Client"
              onClick={() => navigate("/poolcare/post")}
            />

            <Card
              icon={<FaExchangeAlt />}
              color={GREEN}
              title="Swap a Pool Care Client"
              onClick={() => navigate("/poolcare/swaps/post")}
            />

            <Card
              icon={<FaListAlt />}
              color={GREEN}
              title="List a Pool Care Business "
              onClick={() => navigate("/poolcare/businesses/create")}
            />
          </>
        )}
      </div>
    </div>
  );
}

function Card({ icon, title, onClick, color }) {
  return (
    <div style={cardStyle} onClick={onClick}>
      {React.cloneElement(icon, { style: { fontSize: 45, color } })}
      <h3 style={{ color }}>{title}</h3>
    </div>
  );
}

const containerStyle = {
  maxWidth: 800,
  margin: "40px auto",
  padding: "0 20px",
  textAlign: "center",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 20,
};

const cardStyle = {
  background: "#fff",
  padding: 24,
  borderRadius: 12,
  border: "1px solid #e0e0e0",
  textAlign: "center",
  cursor: "pointer",
  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
};

export default SelectType;